import { ThemeProvider } from "@mui/material";
import "./App.css";
import "./i18n";
import Navbar from "./Navbar/Navbar";
import SecondNavbar from "./Navbar/SecondNavbar";
import NavbarSr from "./components/countries/srilanka/Navbar";
import theme from "./theme";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import FranchiseModel from "./pages/FranchiseModel";
import OurPresence from "./pages/OurPresence";
import Blog from "./pages/Blog";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ContactUs from "./pages/Contact";
import Bangladesh from "./components/ourComponent/Bangladesh";
import Nepal from "./components/ourComponent/Nepal";
import Srilanka from "./components/countries/srilanka/homepagesr"; // <-- import Srilanka (homepagesr) here!
import Event from "./pages/Event";
import Media from "./pages/Media";
import BlogPage from "./pages/BlogPage";
import CareerPageHome from "./pages/CareerPage";
import DownloadBroucher from "./pages/DownloadBroucher";
import AbuDhabiEvent from "./pages/AbuDhabiEvent";
import Dubai from "./pages/Dubai";
import SriLankaEvent from "./pages/SriLanka";
import AppContextProvider from "./AppContext";
import Uae from "./components/globalCountries/countries/Uae";
import CountryServices from "./components/globalCountries/countries/CountryServices";
import TermsAndConditions from "./components/globalCountries/countrymainpages/TemsAndConditions";
import PrivacyPolicy from "./components/globalCountries/countrymainpages/privacyPolicy";
import GlobalLocateUs from "./components/HomeComponent/GlobalLocateUs";
import PricingPage from "./components/globalCountries/countrymainpages/PricingPage";
import LocateUsPage from "./components/globalCountries/countrymainpages/LocateUs";
import ViewMorePage from "./components/globalCountries/countrymainpages/ViewMorePage";
import CareerPage from "./components/globalCountries/countrymainpages/CareerPage";
import ThailandEvent from "./pages/ThailanEvent";
import GlobalViewMorePage from "./components/HomeComponent/GlobalViewMore";
import EventDetails from "./components/EventComponent/EventDetails";
import GlobalUpcomingEvent from "./components/HomeComponent/GlobalUpcomingEvent";
import GlobalPastEvent from "./components/HomeComponent/GlobalPastEvent";
import Pricingpagesr from "./components/countries/srilanka/pricingpagesr";
import Locateussr from "./components/countries/srilanka/locateussr";
import Mediacoveragesr from "./components/countries/srilanka/mediacoveragesr";
import Careerpagesr from "./components/countries/srilanka/careerpagesr";
import Blogsr from "./components/countries/srilanka/blogsr";
import Privacypolicysr from "./components/countries/srilanka/privacypolicysr";
import Termsandconditionssr from "./components/countries/srilanka/termsandconditionssr";
import Cleaningstandardssr from "./components/countries/srilanka/cleaningstandardssr";
import Eventssr from "./components/countries/srilanka/eventssr";
import Upcomingeventsdetailssr from "./components/countries/srilanka/upcomingeventsdetailssr";
import Pasteventdetailssr from "./components/countries/srilanka/pasteventdetailssr";
import Contactussr from "./components/countries/srilanka/contactussr";
import ServicesSr from "./components/countries/srilanka/servicessr";
import CleaningStandardsPage from "./pages/CleaningStandards";
import BlogPageUae from "./components/globalCountries/countrymainpages/BlogUae";

// Helper to detect Sri Lanka routes
function isSriLankaPath(pathname) {
  return pathname === "/srilanka" || pathname.startsWith("/srilanka/");
}

function AppWrapper() {
  const location = useLocation();
  const secondNavbarRoutes = [
    "/uae",
    "/uae/pricing-page",
    "/uae/locate-us",
    "/uae/services",
    "/events/abu-dhabi",
    "/uae/terms-and-conditions",
    "/uae/career-page",
    "/uae/privacy-policy",
    "/uae/view-more",
    "/uae/download-brochure",
    "/events/srilanka",
    "/events/dubai",
    "/uae/blog"
  ];

  // Use Sri Lanka navbar on Sri Lanka routes
  if (isSriLankaPath(location.pathname)) {
    return (
      <>
        <NavbarSr />
        <main>
          <Routes>
            {/* Redirect "/srilanka" (no trailing slash) to "/srilanka/" for consistency */}
            <Route path="/srilanka" element={<Navigate to="/srilanka/" replace />} />
            <Route path="/srilanka/" element={<Srilanka />} />
            <Route path="/srilanka/pricing" element={<Pricingpagesr />} />
            <Route path="/srilanka/locateus" element={<Locateussr />} />
            <Route path="/srilanka/mediacoverage" element={<Mediacoveragesr />} />
            <Route path="/srilanka/careers" element={<Careerpagesr />} />
            <Route path="/srilanka/blog" element={<Blogsr />} />
            <Route path="/srilanka/privacypolicy" element={<Privacypolicysr />} />
            <Route path="/srilanka/termsandconditions" element={<Termsandconditionssr />} />
            <Route path="/srilanka/cleaningstandards" element={<Cleaningstandardssr />} />
            <Route path="/srilanka/events" element={<Eventssr />} />
            <Route path="/srilanka/upcomingeventsdetails" element={<Upcomingeventsdetailssr />} />
            <Route path="/srilanka/services" element={<ServicesSr />} />
            <Route path="/srilanka/pasteventdetails" element={<Pasteventdetailssr />} />
            <Route path="/srilanka/contactus" element={<Contactussr />} />
          </Routes>
        </main>
      </>
    );
  }

  // Use SecondNavbar for secondNavbarRoutes, otherwise default Navbar
  const useSecondNavbar = secondNavbarRoutes.includes(location.pathname);

  return (
    <>
      {useSecondNavbar ? <SecondNavbar /> : <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/uae/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/uae/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/uae/pricing-page" element={<PricingPage />} />
          <Route path="/uae/blog" element={<BlogPageUae />} />
          <Route path="/uae/locate-us" element={<LocateUsPage />} />
          <Route path="/locate-us" element={<GlobalLocateUs />} />
          <Route path="/uae/view-more" element={<ViewMorePage />} />
          <Route path="/view-more" element={<GlobalViewMorePage />} />
          <Route path="/uae/career-page" element={<CareerPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/media" element={<Media />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/career" element={<CareerPageHome />} />
          <Route path="/our-presence" element={<OurPresence />} />
          <Route path="/news" element={<Blog />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/bangladesh" element={<Bangladesh />} />
          <Route path="/uae" element={<Uae />} />
          <Route path="/sri-lanka" element={<Srilanka />} />
          <Route path="/nepal" element={<Nepal />} />
          <Route path="/download-brochure" element={<DownloadBroucher />} />
          <Route path="/events" element={<Event />} />
          <Route path="/events-details" element={<EventDetails />} />
          <Route path="/upcoming-event" element={<GlobalUpcomingEvent />} />
          <Route path="/past-event/:id" element={<GlobalPastEvent />} />
          <Route path="/apply-franchise" element={<FranchiseModel />} />
          <Route path="/events/srilanka" element={<SriLankaEvent />} />
          <Route path="/events/thailand" element={<ThailandEvent />} />
          <Route path="/events/abu-dhabi" element={<AbuDhabiEvent />} />
          <Route path="/events/dubai" element={<Dubai />} />
          <Route path="/uae/services" element={<CountryServices />} />
          <Route path="/cleaning-standards" element={<CleaningStandardsPage />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppContextProvider>
        <Router>
          <AppWrapper />
        </Router>
      </AppContextProvider>
    </ThemeProvider>
  );
}

export default App;